import { Stack, Text, UnstyledButton } from '@mantine/core';

import { FaqNodeSearchByIds } from '@mygpt/app/faqs/services/tree';

interface Props {
  list: FaqNodeSearchByIds[] | string[];
  onClick: (value: string, faqID?: string) => void;
  botMessageTextColor?: string;
  isDigitalHuman?: boolean;
}

const RecommendQuestionNodeList: React.FC<Props> = ({ list, onClick, botMessageTextColor, isDigitalHuman }) => {
  const isStringArray = Array.isArray(list) && list.every((item) => typeof item === 'string');

  return (
    <Stack align="flex-start">
      {list.map((item, index) => (
        <UnstyledButton
          key={index}
          className={`max-w-full rounded-lg py-2 px-3 transition-all duration-200 ${
            isDigitalHuman
              ? 'bg-white/90 backdrop-blur-md shadow-lg hover:bg-white hover:shadow-xl border-none'
              : 'bg-white border border-gray-200 hover:border-gray-400 shadow-sm hover:shadow-md'
          }`}
          onClick={() =>
            onClick(
              isStringArray ? (item as string) : (item as FaqNodeSearchByIds).question,
              isStringArray ? undefined : (item as FaqNodeSearchByIds).id
            )
          }
        >
          <Text
            size="xs"
            c={isDigitalHuman ? 'dark' : botMessageTextColor ? undefined : 'violet.7'}
            fw={500}
            style={!isDigitalHuman && botMessageTextColor ? { color: botMessageTextColor } : undefined}
          >
            {isStringArray ? (item as string) : (item as FaqNodeSearchByIds).question}
          </Text>
        </UnstyledButton>
      ))}
    </Stack>
  );
};

export default RecommendQuestionNodeList;
